import { useState, useEffect } from "react";

const useMobile = () => {
  const [windowDimension, setWindowDimension] = useState(null);
  const [landscape, setLandscape] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
    setLandscape(window.innerHeight);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
      setLandscape(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const isLittleScreen = windowDimension <= 1599;
  const isMobile = windowDimension <= 500;
  const isTreizePouces = windowDimension === 1280;
  const isLittleMobile = windowDimension === 360;
  const isLandscape = landscape < 414;
  return {
    isMobile,
    isLittleScreen,
    isTreizePouces,
    isLittleMobile,
    isLandscape,
  };
};

export default useMobile;
